import ShipAddressValidator from "components/ShipAddressValidator/ShipAddressValidator";
import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

export default function LeadAddressAddUpdate({
  leadId,
  formData,
  setFormData,
  isUpdateMode,
  setIsUpdateMode,
  showModal,
  refreshList,
  refreshLead,
  setPageNumber,
  setDefaultShipAddress,
}) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.userInfo);

  const [loading, setLoading] = useState(false);

  const ensureLeadId = () => {
    if (!leadId) {
      dispatch(
        setNotification({
          message: "Missing lead reference",
          type: "error",
        })
      );
      return false;
    }
    return true;
  };

  /*   All Functions
   ********************************************* */
  const handleAddLeadAddress = async (e, address, checkMarks) => {
    e.preventDefault();
    if (!ensureLeadId()) return;

    let body = {
      companyName: address.companyName || "",
      addressLine1: address.addressLine1 || "",
      addressLine2: address.addressLine2 || "",
      city: address.city || "",
      state: address.state || "",
      zip: address.zip || "",
      country: address.country || "",
      addressType: address.addressType || "",
      addressGroundTransitDays: address.addressGroundTransitDays || null,
      authorizePerson: address.authorizePerson || "",
      authorizeLocation: address.authorizeLocation || "",
      serviceId: address.serviceId || "",
      addressDhlTransitDays: address.addressDhlTransitDays || null,
      signatureRelease: checkMarks?.signatureRelease || false,
      selfCollect: checkMarks?.selfCollect || false,
    };

    try {
      setLoading(true);
      const { data } = await API.post("/lead-address/add/" + leadId, body, {
        headers: authHeader(),
      });
      if (data?.success) {
        setFormData({});
        showModal(false);
        if (typeof setPageNumber === "function") {
          setPageNumber(1);
        }
        refreshList({ page: 1 });
        if (refreshLead) {
          refreshLead();
        }
      } else {
        dispatch(setNotification({ message: data?.message, type: "error" }));
      }
    } catch (err) {
      dispatch(setNotification({ message: err.message, type: "error" }));
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateLeadAddress = async (e, address, checkMarks) => {
    e.preventDefault();
    if (!ensureLeadId()) return;

    let body = {
      addressId: address.addressId,
      id: address.id,
      companyName: address.companyName || "",
      addressLine1: address.addressLine1 || "",
      addressLine2: address.addressLine2 || "",
      city: address.city || "",
      state: address.state || "",
      zip: address.zip || "",
      country: address.country || "",
      addressType: address.addressType || "",
      addressGroundTransitDays: address.addressGroundTransitDays || null,
      authorizePerson: address.authorizePerson || "",
      authorizeLocation: address.authorizeLocation || "",
      serviceId: address.serviceId || "",
      addressDhlTransitDays: address.addressDhlTransitDays || null,
      signatureRelease: checkMarks?.signatureRelease || false,
      selfCollect: checkMarks?.selfCollect || false,
    };
    try {
      setLoading(true);
      const { data } = await API.patch("/lead-address/" + leadId, body, {
        headers: authHeader(),
      });
      if (data?.success) {
        setIsUpdateMode(false);
        showModal(false);
        refreshList();
        if (refreshLead) {
          refreshLead();
        }
      } else {
        dispatch(setNotification({ message: data?.message, type: "error" }));
      }
    } catch (err) {
      dispatch(setNotification({ message: err.message, type: "error" }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {loading && <Spinner />}
      <div className="d-flex align-items-center justify-content-between">
        <h3>{isUpdateMode ? " Update Address " : " Add Address "}</h3>
        {(user?.permissions?.includes("customer_delete") ||
          user?.roles === "admin") &&
          isUpdateMode &&
          !formData?.isDefault && (
            <button
              type="button"
              onClick={(e) => {
                setDefaultShipAddress(formData);
              }}
              className="btn btn-sm my-1 me-1 btn-sm btn-success"
            >
              SET DEFAULT
            </button>
          )}
      </div>
      <hr className="mt-0 mb-3" />

      <ShipAddressValidator
        isAddMode={!isUpdateMode}
        shippingAddress={formData}
        showModal={showModal}
        submitFunction={
          isUpdateMode ? handleUpdateLeadAddress : handleAddLeadAddress
        }
      />
    </div>
  );
}
